const Menu =  [
    {   header  : 'Settings' },
    {
        title   : 'Device Register',  
        name    : 'device-register',
        icon    : 'fa-desktop',
        meta    : {public : true, guest : true},  
        
    },
    {
        title   : 'Register Update',  
        name    : 'settings/register-update',
        icon    : 'build',             
    },
    {
        title   : 'RBAC',
        group   : 'rbac',
        icon    : 'pets',                    
        items: [
            {title: 'Routes', name: 'routes'},
            {title: 'Permissions', name: 'permissions'},
            {title: 'Roles', name: 'roles'},
            {title: 'Assignment', name: 'assignment'}            
        ]
    }
];

import Remenu from '@/util/remenu'
export default Remenu(Menu);
